module.exports = __webpack_public_path__ + "media/nf_legis.fc05b5fa.webm";